import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
  entity: {
    id: 0,
    idModelo: 0,
    codigoModelo: "",
    modelo: "",
    idArea: 0,
    codigoArea: "",
    area: "",
    idDestreza: 0,
    codigoDestreza: "",
    destreza: "",
    codigo: "",
    nombre: "",
    descripcion: "",
    orden: 0,
    pregunta: "",
    ejemplo: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
  },
  listArea: [{id: 0, codigo: "", nombre: "", descripcion: ""}],
  listDestreza: [{id: 0, codigo: "", nombre: "", descripcion: ""}],
  validationActive: {
    idArea: false,  
    idDestreza: false,
      codigo: false,
      nombre: false,
      orden: false,
  },
  validationMessage: [],
}

export const areaObjectiveSlice = createSlice({
  name: "areaObjective",
  initialState: {},
  reducers: {
    init: (state, action) => {
      const { sliceKey } = action.payload;
      if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
    },
    setEntity: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].entity = data;
    },
    setData: (state, action) => {
      var { sliceKey, name, value } = action.payload;

      if (name.startsWith("id")) value = parseInt(value)
      if (name.startsWith("orden")) value = parseInt(value)
      
      state[sliceKey].entity[name] = value
      state[sliceKey].validationActive[name] = true
    },
    setListArea: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].listArea = data;
    },
    setListDestreza: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].listDestreza = data;
    },
    setValidationMessage: (state, action) => {
      const {sliceKey, message} = action.payload;
      state[sliceKey].validationMessage = message;
    },
    activeValidations: (state, action) => {
      const {sliceKey} = action.payload;
      Object.keys(state[sliceKey].validationActive).forEach(function (key) {
        state[sliceKey].validationActive[key] = true;
      })
    },
  },
});

export const { init, setEntity, setData, setValidationMessage, activeValidations
  , setListArea, setListDestreza
  } = areaObjectiveSlice.actions;
export const defaultAreaObjective = {
  id: 0,
  idModelo: 0,
  codigoModelo: "",
  modelo: "",
  idArea: 0,
  codigoArea: "",
  area: "",
  idDestreza: 0,
  codigoDestreza: "",
  destreza: "",
  codigo: "",
  nombre: "",
  descripcion: "",
  orden: 0,
  pregunta: "",
  ejemplo: "",
  fechaRegistro: null,
  usuarioRegistro: null,
  fechaModificacion: null,
  usuarioModificacion: null,
}
export default areaObjectiveSlice.reducer;
